export default "__VITE_ASSET__td_7njCI__"